<template>
    <div>
        <label :class="{ 'radio__label': 'radio__label', 'is-active': (modelValue == option.value)}" v-for="(option, index) in data.options" :key="index">
            <input type="radio" :value="option.value" v-model="modelValue" />
            <span class="label" v-html="option.label"></span>
            <span class="label-bg"></span>
        </label>
    </div>
</template>

<script setup>
import { watch, ref } from 'vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
    data: Object,
    required: Boolean,
    default: String,
});

const modelValue = ref(props.default || '');

watch(modelValue, (newValue) => {
    emit('update:modelValue', newValue);
});

watch(() => props.data, (newData) => {
    modelValue.value = ref(props.default || '');
}, { deep: true });

</script>

<style lang="scss" scoped>

.is-required {
    .radio__label {
        border-radius: 4px;
        border: 2px solid #C10707;
        background: linear-gradient(0deg, #FFF 0%, #FFF 100%), linear-gradient(0deg, #B7E3FF 0%, #B7E3FF 100%), #53D1C5;
    }
}

.radio__label {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    border-radius: 4px;
    padding: 18px 20px;
    border-radius: 4px;
    border: 1px solid #DDD;
    background: #FFF;
    cursor: pointer;
    height: 70px;

    @media (min-width: 768px) {
        padding: 28px 20px;
    }

    &.is-active {
       background: #B7E3FF;
    }

    input[type=radio],
    input[type=checkbox]{
        width: 30px;
        height: 30px;
        flex-shrink: 0;
    }

    input[type=radio]:checked::before,
    input[type=checkbox]:checked::before{
        width: 30px;
        height: 30px;
        top: -2px;
        left: -2px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30' fill='none'%3E%3Ccircle cx='15' cy='15' r='15' fill='%231A2041'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M21.0104 12.2424L19.2427 10.4746L13.5861 16.1312L10.758 13.303L8.99023 15.0708L11.8181 17.8992L13.5864 19.667L15.3539 17.8989L21.0104 12.2424Z' fill='white'/%3E%3C/svg%3E");
    }
}

</style>